import {Component} from '@angular/core';
import {PreviousUrlService} from '../../../_services/previous-url.service';

@Component({
	selector: 'app-kvvm-reports-router',
	templateUrl: './reports-router.component.html'
})

export class KVVMReportsRouterComponent {
	constructor(public previousUrlService: PreviousUrlService) {}
}
